module.exports = __webpack_public_path__ + "static/media/food-2.103a5d5b.jpeg";